class CookieBanner {
  constructor() {
    this.banner = document.getElementById('cookie-banner');
    if (!this.banner) return;

    this.consentKey = 'cookie-consent';
    this.init();
  }

  init() {
    // Check if consent already given
    if (this.hasConsent()) {
      this.hideBanner();
      return;
    }

    // Show banner if no consent
    this.showBanner();
    this.bindEvents();
  }

  hasConsent() {
    const consent = localStorage.getItem(this.consentKey);
    return consent === 'accepted' || consent === 'declined';
  }

  getConsent() {
    return localStorage.getItem(this.consentKey);
  }

  setConsent(value) {
    localStorage.setItem(this.consentKey, value);
    this.triggerConsentEvent(value);
  }

  showBanner() {
    if (this.banner) {
      this.banner.style.display = 'block';
      // Force reflow for animation
      this.banner.offsetHeight;
      this.banner.classList.add('cookie-banner--visible');
    }
  }

  hideBanner() {
    if (this.banner) {
      this.banner.classList.remove('cookie-banner--visible');
      // Hide after animation
      setTimeout(() => {
        this.banner.style.display = 'none';
      }, 300);
    }
  }

  bindEvents() {
    const acceptButton = this.banner.querySelector('[data-action="accept"]');
    const declineButton = this.banner.querySelector('[data-action="decline"]');
    const settingsButton = this.banner.querySelector('[data-action="settings"]');

    if (acceptButton) {
      acceptButton.addEventListener('click', () => this.handleAccept());
    }

    if (declineButton) {
      declineButton.addEventListener('click', () => this.handleDecline());
    }

    if (settingsButton) {
      settingsButton.addEventListener('click', () => this.handleSettings());
    }
  }

  handleAccept() {
    this.setConsent('accepted');
    this.hideBanner();
  }

  handleDecline() {
    this.setConsent('declined');
    this.hideBanner();
  }

  handleSettings() {
    // Open cookie settings modal or page
    // This could be customized based on your needs
    console.log('Cookie settings clicked - implement your settings modal/page here');
  }

  triggerConsentEvent(consent) {
    // Dispatch custom event for analytics or other scripts to listen to
    const event = new CustomEvent('cookieConsent', {
      detail: { consent: consent }
    });
    document.dispatchEvent(event);

    // Also trigger Google Analytics consent update if available
    if (typeof gtag !== 'undefined') {
      gtag('consent', 'update', {
        analytics_storage: consent === 'accepted' ? 'granted' : 'denied',
        ad_storage: consent === 'accepted' ? 'granted' : 'denied'
      });
    }

    // Facebook Pixel consent update
    if (typeof fbq !== 'undefined') {
      if (consent === 'accepted') {
        fbq('consent', 'grant');
      } else {
        fbq('consent', 'revoke');
      }
    }
  }

  // Static method to check consent status from anywhere
  static hasConsent() {
    return localStorage.getItem('cookie-consent') === 'accepted';
  }

  static getConsent() {
    return localStorage.getItem('cookie-consent');
  }

  // Method to reset consent (useful for testing or GDPR compliance)
  static resetConsent() {
    localStorage.removeItem('cookie-consent');
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CookieBanner();
});

// Export for use in other scripts
window.CookieBanner = CookieBanner;
